<header>
  <kin-icon [name]="icon()" />
  <h5>{{ title() | translate }}</h5>
</header>

<p class="file-data">
  {{ 'common.file.name' | translate }} <span class="data">{{ fileName() }}</span> - {{ 'common.file.duration' | translate }} <span class="data">{{ (fileDuration() ?? 0) |
    formatDuration }}</span>
  @if (fileWeight() !== undefined) {
  -
  {{ 'common.file.weight' | translate }} <span class="data">{{ (fileWeight() ?? 0) | fileSize}}</span>
  }
</p>

<div class="download-progress">
  <kin-icon name="upload" [color]="colorService.neutral600()" />
  <div class="progress-container">
    <div [style]="'width:' + progress() + '%'" [class]="['progress', uploadStatus()]"></div>
  </div>
  <p>
    <span class="strong">{{ progress() }}</span>%
  </p>
</div>

<div class="download-status">
  @switch (uploadStatus()) {
  @case ('in_progress') {
  <kin-wheel-loader [size]="24" />
  }
  @case ('complete') {
  <kin-icon name="g_validate" [color]="colorService.success()" />
  }
  }
  <p [style]="
      'color:' +
      (uploadStatus() === 'complete' ? colorService.success700() : colorService.neutral500())
    ">
    {{ 'upload.progress_block.status.' + uploadStatus() | translate | upperFirstLetter }}
  </p>
</div>